module.exports = {
  TICKET_DISABLED_PERSONS_PARKING_SPOT: 'ticket-disabled-persons-parking-spot',
  TICKET_ELECTRIC_VEHICLE_CHARGING_SPOT: 'ticket-electric-vehicle-charging-spot',
  TICKET_INVADING_BUS_LANE: 'ticket-invading-bug-lane',
  TICKET_LOADING_UNLOADING_ZONE: 'ticket-loading-unloading-zone',
  TICKET_PARKING: 'ticket-parking',
  TICKET_SPEED: 'ticket-speed',
  TICKET_STOP_SIGN_PASSING: 'ticket-stop-sign-passing',
  TICKET_TEMPORARY_RESTRICTION: 'ticket-temporary-restriction',
  TICKET: 'ticket',
  TOLL: 'toll',
  OTHER: 'other',
};
